export default __webpack_public_path__ + "static/media/Price_And_Shipping_Update_Summary_27112025.1be3a1e6.zip";